<script>
  import { writable } from "svelte/store";
  import tinymce from "tinymce";
  import { allowSomeCommandsToEditCustomVars } from "../../../../src/assets/js/src/general/elements/tinymce";
  import { addSourceWhaleButtonsByToolbar } from "../../../../src/assets/js/src/general/elements/tinymce-buttons";
  import { userStore } from "../../../../src/svelte/api-stores/user-store";
  import FloatingUI from "../../utils/FloatingUI.svelte";
  import { populateToolbarButtonStore } from "./utils";

  export let value = "";
  let cls = "";
  export { cls as class };
  export let tag = "textarea";
  export let format = "html";
  export let attachmentIds = null;
  export let customVariables = null;
  export let onBlur;
  export let options = $$restProps;

  let editor = null;

  export const focus = () => editor?.focus();
  $: if (editor && value !== editor.getContent({ format })) {
    editor.setContent(value);
  }

  const toolbarButtons = writable([]);
  const attachmentIdsStore = writable(attachmentIds);

  // store -> local
  attachmentIdsStore.subscribe((x) => {
    attachmentIds = x;
  });

  // local -> store
  $: if (attachmentIds !== $attachmentIdsStore) {
    attachmentIdsStore.set(attachmentIds);
  }

  const action = (target) => {
    const init = async () => {
      [editor] = await tinymce.init({
        ...options,
        target,
        setup: (ed) => {
          if (options.setup) {
            options.setup(ed);
          }
          if (options.toolbar) {
            addSourceWhaleButtonsByToolbar(options.toolbar, {
              editor: ed,
              getUser: () => $userStore || {},
              currentAttachmentIdsStore: attachmentIdsStore,
              customVariables,
            });
          }
        },
      });

      // Now we're out of shadow DOM, make sure we don't let legacy changes to TinyMCE styling affect
      editor.editorContainer.setAttribute("data-sw-ds", "");

      allowSomeCommandsToEditCustomVars(editor);
      editor.setContent(value);

      const setBoundValue = () => {
        value = editor.getContent({ format });
      };
      const addClass = (c) => {
        editor.editorContainer.classList.add(c);
        editor.getBody().classList.add(c);
      };
      const removeClass = (c) => {
        editor.editorContainer.classList.remove(c);
        editor.getBody().classList.remove(c);
      };

      editor.on("input", setBoundValue);
      editor.on("ExecCommand", setBoundValue);

      editor.on("focus", () => addClass("focused"));
      editor.on("blur", (event) => {
        removeClass("focused");
        if (onBlur) onBlur(event, editor);
      });
      editor.editorContainer.addEventListener("mouseenter", () =>
        addClass("hovered")
      );
      editor.editorContainer.addEventListener("mouseleave", () =>
        removeClass("hovered")
      );

      if (cls) {
        cls.split(" ").forEach((c) => editor.editorContainer.classList.add(c));
      }
      populateToolbarButtonStore(editor, toolbarButtons);

      return editor;
    };
    init();
    return {
      destroy: () => {
        tinymce.remove(editor);
        editor = null;
      },
    };
  };
</script>

{#if tag === "input"}
  <input class={cls} use:action />
{:else}
  <textarea class={cls} use:action></textarea>
{/if}

{#each $toolbarButtons as tooltipButton}
  {@const { referenceEl, hovered, focused, title } = tooltipButton}
  {#if hovered || focused}
    <FloatingUI {referenceEl} placement="top" class="sw-svelte-tooltip">
      {title}
    </FloatingUI>
  {/if}
{/each}
